var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTaskModalMenuIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.73478 0.10536 0.48043 0.29289 0.29289C0.48043 0.10536 0.73478 0 1 0H13C13.2652 0 13.5196 0.10536 13.7071 0.29289C13.8946 0.48043 14 0.73478 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2H1C0.73478 2 0.48043 1.89464 0.29289 1.70711C0.10536 1.51957 0 1.26522 0 1ZM0 6C0 5.73478 0.10536 5.48043 0.29289 5.29289C0.48043 5.10536 0.73478 5 1 5H7C7.2652 5 7.5196 5.10536 7.7071 5.29289C7.8946 5.48043 8 5.73478 8 6C8 6.2652 7.8946 6.5196 7.7071 6.7071C7.5196 6.8946 7.2652 7 7 7H1C0.73478 7 0.48043 6.8946 0.29289 6.7071C0.10536 6.5196 0 6.2652 0 6ZM0 11C0 10.7348 0.10536 10.4804 0.29289 10.2929C0.48043 10.1054 0.73478 10 1 10H13C13.2652 10 13.5196 10.1054 13.7071 10.2929C13.8946 10.4804 14 10.7348 14 11C14 11.2652 13.8946 11.5196 13.7071 11.7071C13.5196 11.8946 13.2652 12 13 12H1C0.73478 12 0.48043 11.8946 0.29289 11.7071C0.10536 11.5196 0 11.2652 0 11Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskModalMenuIcn);
export default __webpack_public_path__ + "static/media/addTaskModalMenuIcn.c9793152e057510c27b3366900779b30.svg";
export { ForwardRef as ReactComponent };